import React, { useState, useEffect, useCallback } from 'react';
import { Rocket, Mail, Phone, Building2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PRODUCT_COLORS = { care: '#0E8577', fit: '#E8590C', dance: '#7C3AED' };

const PilotRequests = ({ authHeaders, onAuthError }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/pilot-requests`, { headers: authHeaders() });
      setRequests(res.data);
    } catch (error) {
      if (!onAuthError(error)) console.error('Error loading pilot requests:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return <div className="bg-white rounded-2xl p-8 text-center text-[#86868B]">Laden…</div>;
  }

  if (!requests.length) {
    return (
      <div className="bg-white rounded-2xl p-12 text-center" data-testid="pilot-requests-empty">
        <Rocket className="w-10 h-10 text-[#86868B] mx-auto mb-4" strokeWidth={1.5} />
        <p className="text-[#86868B]">
          Noch keine Pilotkunden-Anfragen. Sobald jemand auf «Bald verfügbar – Pilotkunde werden» klickt
          und das Formular absendet, erscheint die Anfrage hier.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="pilot-requests-list">
      {requests.map((req) => (
        <div key={req.id} className="bg-white rounded-2xl p-6" data-testid={`pilot-request-${req.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
            <span
              className="text-xs font-semibold text-white px-3 py-1 rounded-full"
              style={{ backgroundColor: PRODUCT_COLORS[req.product] || '#0071E3' }}
              data-testid={`pilot-product-chip-${req.product}`}
            >
              {req.product_name || req.product}
            </span>
            <p className="text-sm text-[#86868B]">
              {new Date(req.timestamp).toLocaleString('de-CH')}
            </p>
          </div>
          <p className="text-lg font-medium text-[#1D1D1F] mb-2">{req.name}</p>
          <div className="flex flex-wrap gap-x-6 gap-y-1.5 text-sm text-[#424245]">
            {req.company && (
              <span className="inline-flex items-center gap-1.5">
                <Building2 className="w-4 h-4 text-[#86868B]" strokeWidth={1.5} />{req.company}
              </span>
            )}
            <a href={`mailto:${req.email}`} className="inline-flex items-center gap-1.5 text-[#0071E3] hover:underline">
              <Mail className="w-4 h-4" strokeWidth={1.5} />{req.email}
            </a>
            {req.phone && (
              <a href={`tel:${req.phone}`} className="inline-flex items-center gap-1.5 text-[#0071E3] hover:underline">
                <Phone className="w-4 h-4" strokeWidth={1.5} />{req.phone}
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PilotRequests;
